import '@/styles/globals.css'
import 'reshaped/themes/zora-ui/theme.css'
import { useTrackUser } from '@/hooks/useTrackUser'
import { PRIVY_API_URL, PRIVY_APP_ID, PRIVY_CLIENT_ID, privyConfig } from '@/lib/privy'
import { queryClient } from '@/lib/reactQuery'
import { createEnvironment } from '@/lib/relay'
import { trpc } from '@/lib/trpc'
import { WAGMI_CONFIG } from '@/lib/wagmi'
import { PostHogProvider } from '@/providers/PostHogProvider'
import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google'
import { PrivyProvider } from '@privy-io/react-auth'
import { WagmiProvider } from '@privy-io/wagmi'
import { QueryClientProvider } from '@tanstack/react-query'
import type { AppProps } from 'next/app'
import { RelayEnvironmentProvider } from 'react-relay'
import { Reshaped } from 'reshaped'

const environment = createEnvironment()

/**
 * Component that includes tracking hooks and renders page components
 */
function AppContent({ Component, pageProps }: AppProps) {
  // Setup user tracking
  useTrackUser()

  return <Component {...pageProps} />
}

function App(props: AppProps) {
  return (
    <PrivyProvider
      appId={PRIVY_APP_ID}
      clientId={PRIVY_CLIENT_ID}
      config={privyConfig}
      // @ts-ignore
      apiUrl={PRIVY_API_URL}
    >
      <GoogleTagManager
        gtmId={process.env.NEXT_PUBLIC_TOKEN_CLAIM_GOOGLE_TAG_MANAGER_ID!}
      />
      <GoogleAnalytics gaId={process.env.NEXT_PUBLIC_TOKEN_CLAIM_GOOGLE_ANALYTICS_ID!} />
      <QueryClientProvider client={queryClient}>
        <WagmiProvider config={WAGMI_CONFIG}>
          <RelayEnvironmentProvider environment={environment}>
            <Reshaped
              theme="zora-ui"
              toastOptions={{
                bottom: { width: '440px' },
              }}
            >
              <PostHogProvider>
                <AppContent {...props} />
              </PostHogProvider>
            </Reshaped>
          </RelayEnvironmentProvider>
        </WagmiProvider>
      </QueryClientProvider>
    </PrivyProvider>
  )
}

export default trpc.withTRPC(App)
